import windowExists from 'linna/util/windowExists'

import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import env from '@/env'

import modules from './modules'

const vuexBlueprint = {
  strict: env.isDev,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  plugins: []
}

// Combine state, getters etc...
for (const vuexKey in vuexBlueprint) {
  // ...from all modules
  for (const moduleName in modules) {
    // ...that have them
    if (modules[moduleName][vuexKey]) {
      // NOTE: not using spread operator so we can detect duplicates
      for (const key in modules[moduleName][vuexKey]) {
        if (vuexBlueprint[vuexKey][key]) {
          throw new Error('Duplicate key in vuex ' + vuexKey + ' (' + key + ')')
        }

        vuexBlueprint[vuexKey][key] = modules[moduleName][vuexKey][key]
      }

      // Could use spread operator in production instead
      // vuexBlueprint[vuexKey] = {
      //   ...vuexBlueprint[vuexKey],
      //   ...modules[moduleName][vuexKey]
      // }
    }
  }
}

// https://www.npmjs.com/package/vuex-persist
if (windowExists() && window.localStorage) {
  // Control what values to store
  // const reducer = (state) => { return state }

  // Control which mutations to trigger save for
  // const filter = ({ type }) => { return type === 'foo' ? true : false }

  const vuexPersist = new VuexPersistence({
    storage: window.localStorage
    // reducer
    // filter
  })

  vuexBlueprint.mutations.RESTORE_MUTATION = vuexPersist.RESTORE_MUTATION

  vuexBlueprint.plugins.push(vuexPersist.plugin)
}

Vue.use(Vuex)

export default new Vuex.Store(vuexBlueprint)
